import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tryAgain: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.try-again',
		defaultMessage: 'Try again',
		description: 'Text for button to retrieve data again',
	},
	maxListHelperText: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.max-list-helper-text',
		defaultMessage: 'Select up to {maxListCount, plural, one {# list} other {# lists}}',
		description: 'Helper text for maximum number of lists that can be selected',
	},
	maxListError: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.max-list-error',
		defaultMessage:
			'Please select a maximum of {maxListCount, plural, one {# list} other {# lists}}.',
		description: 'Error message when user tries to select more than 10 lists',
	},
});
